module.exports = __webpack_public_path__ + "static/media/Portada_Plantilla.4a217edd.png";